import { Component } from '@angular/core';

import { BoxComponent, PlaceloaderComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-candidate-offer-evaluation-skeleton',
  templateUrl: './candidate-offer-evaluation-skeleton.component.html',
  styleUrl: './candidate-offer-evaluation-skeleton.component.less',
  imports: [BoxComponent, PlaceloaderComponent],
})
export class CandidateOfferEvaluationSkeletonComponent {}
